import { render, staticRenderFns } from "./SwitchItem.vue?vue&type=template&id=f45eced6&scoped=true&lang=pug"
import script from "./SwitchItem.vue?vue&type=script&lang=js"
export * from "./SwitchItem.vue?vue&type=script&lang=js"
import style0 from "./SwitchItem.vue?vue&type=style&index=0&id=f45eced6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45eced6",
  null
  
)

export default component.exports